<template>
    <section class="tribute-input-container" :class="isModalDisplay ? 'rd-mt-3' : 'rd-mt-6'">
        <span class="rd-flex rd-font-bold" :class="isModalDisplay ? 'rd-mb-2.5' : 'rd-mb-4'">{{
            component.customData.tributeInformationLabel }}</span>

        <section class="input-container">
            <div class="form-row" :class="{ 'md:rd-gap-x-4': fieldStyle != FieldStyle.Compact }">
                <ValidatedInput :id="component.id" :value="renderStore.tribute.tributeFirstName" label="First Name"
                    class="rd-w-full md:rd-flex-equal"
                    :class="{ 'rd-mb-4 md:rd-mb-0': fieldStyle != FieldStyle.Compact }" name="tributeFirstName"
                    :isRequired="true" :maxLength="75">
                    <template #input="inputProps">
                        <input type="text" v-model="renderStore.tribute.tributeFirstName" placeholder="First Name"
                            :aria-describedby="inputProps.describedBy ?? undefined" aria-required="true"
                            :aria-invalid="inputProps.isInvalid" :id="component.id + '_tributeFirstName'" />
                    </template>
                </ValidatedInput>

                <ValidatedInput :id="component.id" :value="renderStore.tribute.tributeLastName" label="Last Name"
                    class="rd-w-full md:rd-flex-equal" name="tributeLastName" :isRequired="true" :maxLength="75">
                    <template #input="inputProps">
                        <input type="text" v-model="renderStore.tribute.tributeLastName" placeholder="Last Name"
                            :aria-describedby="inputProps.describedBy ?? undefined" aria-required="true"
                            :aria-invalid="inputProps.isInvalid" :id="component.id + '_tributeLastName'" />
                    </template>
                </ValidatedInput>
            </div>
        </section>

        <section v-if="component.customData.showTributeAddress" class="input-container"
            :class="isModalDisplay ? '!rd-mt-2.5' : '!rd-mt-4'">
            <div :class="{ 'fields-compact': fieldStyle == FieldStyle.Compact }">
                <AddressContainer :id="component.id + '_tributeAddress'"
                    :passedAddress="renderStore.tribute.tributeAddress" :required="false" name="Tribute Address"
                    address1Label="Tribute Address" address1Placeholder="Address 1" address2Placeholder="Address 2"
                    cityPlaceholder="City" statePlaceholder="State" postalPlaceholder="Postal Code"
                    countryPlaceholder="Country" @update-address="updateAddress" />
            </div>
        </section>
    </section>
</template>

<script lang="ts">
import { defineComponent, PropType, Ref, inject, computed } from "vue";
import ValidatedInput from "@/builder/components/input/ValidatedInput.vue";
import { useRenderStore } from "@/builder/stores/renderStore";
import { ITributeComponent } from "./TributeInterface";
import AddressContainer from "@/builder/components/input/AddressContainer.vue";
import { PageDesign } from "../page/PageInterface";
import { FieldStyle, PartialDisplayType } from "@/builder/enums";

export default defineComponent({
    name: "TributeInputComponent",
    props: {
        component: {
            type: Object as PropType<ITributeComponent>,
            required: true
        }
    },
    components: {
        ValidatedInput,
        AddressContainer
    },
    setup() {
        const renderStore = useRenderStore();
        const pageDesign = inject("pageDesign") as Ref<PageDesign>;
        const fieldStyle = computed(() => {
            return pageDesign.value.fieldStyle;
        });
        return { renderStore, fieldStyle, FieldStyle };
    },
    computed: {
        isModalDisplay() {
            return this.renderStore.page.partialDisplayType === PartialDisplayType.Modal;
        }
    },
    methods: {
        updateAddress(address: any) {
            this.renderStore.tribute.tributeAddress = address;
        },
    },
});
</script>
